import gql from 'graphql-tag';

export default gql`
  query getTrendingSearches {
    getTrendingSearches {
      title
      url
    }
  }
`;
